<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    v-if="sub"
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >        
        <material-card
          color="blue"
          title="Summary"
        >
          <v-container>
            <v-layout row wrap align-center>
              <v-flex xs12 lg2>
                <v-icon :size="150">mdi-domain</v-icon>
              </v-flex>
              <v-flex xs12 lg10>
                
                <v-form v-model="summaryValid">
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Name"
                          v-model="sub.name"
                          :rules="[rules.required, rules.minLength(5), rules.maxLength(63)]"
                        ></v-text-field>
                      </v-flex>      

                      <v-flex xs12>
                        <v-textarea
                          label="Description"
                          v-model="sub.desc"
                          :rules="[]"
                        ></v-textarea>
                      </v-flex>

                      <v-flex xs12>
                        <div style="text-align:right;">
                          <v-btn
                            :disabled="!isDirty"
                            color="primary"
                            @click="applyChanges"
                          >{{ summarySaving ? "Saving..." : "Apply"}}</v-btn>
                          <v-btn
                            :disabled="!isDirty"
                            color="primary"
                            @click="discardChanges"
                          >Discard</v-btn>
                        </div>
                      </v-flex>

                    </v-layout>
                  </v-container>
                </v-form>
                
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import store from '@/store'
import moment from 'moment'
import { mapState, mapActions, mapGetters } from 'vuex'
import { stringify } from 'querystring';

export default {
  components: {
  },
  
  data() {
    return {
      summaryValid: false,
      summarySaving: false,
      origSub: null,
      sub: null,      

      rules: {
        required: v => !!v || 'Value is required.',
        minLength(len) { return v => (v || '').length >= len || `Value is too short. Must be greater than ${len} characters.` },
        maxLength(len) { return v => (v || '').length <= len || `Value is too long. Must be less than than ${len} characters.` },
        serialNo: v=> /\d{3}-\d{3}/.test(v || '') || 'Invalid serial number format. Value must be in 123-456 format.',
      },
    }
  },

  mounted() {
    if (this.atmosInitialized) {
        this.loadSub();
    }
  },

  watch: {
    atmosInitialized: function(val, oldVal) {
        this.loadSub();
    },

    sub: function(val, oldVal) {
      this.origSub = this.atmosSubscriptions.find(i => i.id == this.$route.params.id);
    }
  },

  computed: {
    ...mapState('atmos', [
      'atmosInitialized'
    ]),

    ...mapGetters('atmos', [
      'atmosSubscription',
      'atmosSubscriptions'
    ]),

    isDirty() {
      return JSON.stringify(this.sub) != JSON.stringify(this.origSub);
    },

  },

  filters: {
  },

  methods: {
    ...mapActions('atmos', [
      'atmosUpdateSubscription'
    ]),

    loadSub() {
        this.sub = Object.assign({}, this.atmosSubscriptions.find(i => i.id == this.$route.params.id));
    },

    discardChanges() {
      this.sub = Object.assign({}, this.origSub);
    },

    async applyChanges() {
      this.summarySaving = true;
      try {
        await this.atmosUpdateSubscription({
          id: this.sub.id,
          name: this.sub.name, 
          sn: this.sub.sn, 
          desc: this.sub.desc
        });

        this.loadSub();
      }
      catch (err) {
        alert(err);
      } finally {
        this.summarySaving = false;        
      }
    }

  }  

}
</script>
